import {Component, Input} from '@angular/core';
import {GAService} from "../../../root/ga/ga.service";
import {ActivatedRoute} from "@angular/router";
import * as moment from "moment";
import {DateService} from "../../../core/date.service";

@Component({
    selector: 'pickup-week',
    providers: [DateService],
    templateUrl: 'pickup-week.component.html'
})
export class PickupWeekComponent{

    @Input()
    pickupList: any;

    constructor(private gaService:GAService, private activatedRoute:ActivatedRoute, private dateService:DateService){}

    routeReserveList(day) {
        this.activatedRoute.params.subscribe(params => {
            var companyId = params['id'];
            this.goToReservationList(day, companyId);
        });

    }

    goToReservationList(day, companyId: any) {
        var diffDays = moment(day, 'YYYY-MM-DD').diff(moment(), 'days');
        this.gaService.notify("Autos_inicio_pickup", "seleccionar_reserva", [diffDays]);
        var datePlusWeek = new Date(day);
        var dataType = "PICK_UP";
        datePlusWeek.setDate(datePlusWeek.getDate() + 1);
        var url = `company/${companyId}/booking?from=${this.dateService.formatDateToYYYYMMDD(datePlusWeek)}&to=${this.dateService.formatDateToYYYYMMDD(datePlusWeek)}&landing=true`
        window.open(url);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/home/pickup-week/pickup-week.component.ts